import { FormikProvider } from 'formik';
import XMultiImageUpload from '../../pages/admin/cases/component/XMultiImageUpload';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import useCaseAccidentScene from '../../hooks/useCaseAccidentScene';

// Renders accident scene image upload section
const CaseAccidentScene = () => {
  const { formik, selectedDefendant } = useAddCaseFormContext();
  const {
    isLoading,
    handleAccidentSceneUpload,
    handleAccidentSceneRemove,
    handleAccidentSceneIsSelectedChange,
    handleAccidentSceneDefendantsChange
  } = useCaseAccidentScene();

  const defendants = formik.values.defendants || [];
  const accidentSceneFiles = formik.values.liability?.accidentSceneFiles || [];

  return (
    <FormikProvider value={formik}>
      <XMultiImageUpload
        heading="Accident Scene and Property Damage Photos"
        label="Accident Scene and Property Damage Photos"
        name="accidentReportImageFiles"
        acceptedFileTypes=".jpg,.jpeg,.png,.heic,.heif"
        initialFiles={accidentSceneFiles}
        onChange={handleAccidentSceneUpload}
        defendants={defendants}
        formik={formik}
        selectedDefendant={selectedDefendant}
        isLoading={isLoading}
        onIsSelectedChange={( s3UrlPath, isSelected ) =>
          handleAccidentSceneIsSelectedChange({ s3UrlPath, isSelected })
        }
        onRemove={handleAccidentSceneRemove}
        onDefendantsChange={( s3UrlPath, defendants ) =>
          handleAccidentSceneDefendantsChange({ s3UrlPath, defendants })
        }
      />
    </FormikProvider>
  );
};

export default CaseAccidentScene;
